// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.headers
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Int
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.network.model.ClientResponseEntity
import org.mifospay.core.network.model.entity.Page
import org.mifospay.core.network.model.entity.client.ClientAccountsEntity
import org.mifospay.core.network.model.entity.client.ClientEntity
import org.mifospay.core.network.model.entity.client.NewClientEntity
import org.mifospay.core.network.model.entity.client.UpdateClientEntity

@OptIn(InternalKtorfitApi::class)
public class _ClientServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : ClientService {
  override suspend fun clients(): Flow<Page<ClientEntity>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "clients")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<Page<ClientEntity>>>(),)!! 
  }

  override suspend fun getClientForId(clientId: Long): ClientEntity {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "clients/${"$clientId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<ClientEntity>(),)!! 
  }

  override fun getClient(clientId: Long): Flow<ClientEntity> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "clients/${"$clientId".encodeURLPath()}")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<ClientEntity>>(),)!! 
  }

  override suspend fun updateClient(clientId: Long, payload: UpdateClientEntity) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "clients/${"$clientId".encodeURLPath()}")
        }
        setBody(payload) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override fun getClientImage(clientId: Long): Flow<String> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "clients/${"$clientId".encodeURLPath()}/images")
        }
        headers{
        append("Accept", "text/plain")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<String>>(),)!! 
  }

  override suspend fun updateClientImage(clientId: Long, typedFile: String) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "clients/${"$clientId".encodeURLPath()}/images")
        }
        setBody(typedFile) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun getClientAccounts(clientId: Long): ClientAccountsEntity {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "clients/${"$clientId".encodeURLPath()}/accounts")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<ClientAccountsEntity>(),)!! 
  }

  override fun getAccounts(clientId: Long, accountType: String): Flow<ClientAccountsEntity> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "clients/${"$clientId".encodeURLPath()}/accounts")
        accountType?.let{ parameter("fields", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<ClientAccountsEntity>>(),)!! 
  }

  override suspend fun createClient(newClient: NewClientEntity): ClientResponseEntity {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "clients")
        }
        setBody(newClient) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<ClientResponseEntity>(),)!! 
  }

  override suspend fun deleteClient(clientId: Int): ClientResponseEntity {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("DELETE")
        url{
        takeFrom(_baseUrl + "clients/${"$clientId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<ClientResponseEntity>(),)!! 
  }
}

public class _ClientServiceProvider : ClassProvider<ClientService> {
  override fun create(_ktorfit: Ktorfit): ClientService = _ClientServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createClientService(): ClientService = _ClientServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
